import {
  isPDP,
  normalizeBrand,
  getItemCategory,
  getItemCategory2,
  getProductByRefId,
  extractRefIdFromUrl,
} from '../../utils';

export async function itemsFromBanner(context: Record<string, any>) {
  const isUrlFromPDP = isPDP(context?.bannerUrl);

  if (!isUrlFromPDP) return [];

  const product = await getProductByRefId(context?.bannerUrl);

  const item = product?.items[0];

  return {
    price: item?.sellers[0].commertialOffer.Price || 0,
    quantity: 1,
    item_ref: extractRefIdFromUrl(context?.bannerUrl),
    item_brand: normalizeBrand(product.brand) || null,
    item_name: product?.productName || product?.alternateName || product?.item_name || null,
    item_category: getItemCategory(product) || null,
    item_variant: item?.name?.split("-").pop().trim() || null,
    item_category2: getItemCategory2(product) || null,
    item_id: product?.productId || null,
    discount: item?.sellers[0].commertialOffer.ListPrice - item?.sellers[0].commertialOffer.Price || null,
  }
}
